import React, { useState, useEffect } from 'react';
import styles from './Select.module.css';
import { Dropdown } from 'react-bootstrap';
import IconButton from 'components/IconButton';

const initialState = {
  label: '', value: '', icon: '' 
}

const CustomSelect = ({ options, onSelect, defaultTitle, defaultValues, type }) => {
  const [selected, setSelected] = useState(defaultValues ? defaultValues : initialState);

  useEffect(() => {
    selected?.value && onSelect(selected?.value);
  }, [selected?.value]);

  const handleSelectChange = (option) => {
    setSelected(option);
  };

  return (
    <Dropdown size="sm" variant="secondary">
      <Dropdown.Toggle className={styles.customDropdownButton}>
          {defaultTitle}
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropDownMenu}>
        {options.map((option, index) => (
          <Dropdown.Item
            key={index}
            eventKey={option.value}
            className={styles.dropdownItem}
            onClick={() => handleSelectChange(option)}
          >
            <div className={styles.items}>
              {option?.icon && <IconButton src={option.icon} className={styles.IconButton}/>}
              { type === 'FONT_FAMILY' ? <span style={{fontFamily : option.value}}>{option.label}</span> : <>{option?.label && option.label}</>}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomSelect;